var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"persistent":"","z-index":"250"},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary","width":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }